module.exports = require("@swa-ui/dotcom/src/DotcomFooter/DotcomMobileFooter/DotcomMobileFooter.module.scss");